import React, { createContext, useContext } from "react";

// project-imports
import { postData } from "./salesforce_api_context";
import {
    CREATE_BUG_BEGIN,
    CREATE_BUG_FAILURE,
    CREATE_BUG_SUCCESS,
} from "../constants/actions";
import { getOrCreateGuestId } from "../utils";
import { LONGSWITCH_ACADEMY } from "../constants";

// third-party
import { useDispatch, useSelector } from "react-redux";

// Create context
export const BugContext = createContext();

export const BugProvider = (props) => {
    // Reading store data
    const bugState = useSelector((state) => state.bug);

    const { loginData } = useSelector((item) => item.user);

    // Reading dispatch from Store
    const dispatch = useDispatch();

    // constants variables
    const browser = navigator.userAgentData && navigator.userAgentData?.brands && navigator.userAgentData?.brands?.length ? navigator.userAgentData?.brands?.[0]?.brand : "Unknown Browser";
    const browserVersion = navigator.userAgentData && navigator.userAgentData?.brands && navigator.userAgentData?.brands?.length ? navigator.userAgentData?.brands?.[0]?.version : "Unknown";
    const os = navigator.userAgentData?.platform || "Unknown OS";
    const device = navigator.userAgentData?.mobile ? "Mobile" : "Desktop";
    const userId = loginData && loginData?.data ? loginData?.data?.userRecordId : getOrCreateGuestId();

    let osVersion = "Unknown";

    // Constant function
    // Function to handle bugReport
    const bugReport = async (payload) => {
        try {
            // Dispatching the action to begin
            dispatch({ type: CREATE_BUG_BEGIN, payload: true });

            // Calling API to post bug report
            let response = await postData("/api/bug", payload);

            // Dispatching the actions on success
            dispatch({ type: CREATE_BUG_SUCCESS, payload: response });
        } catch (error) {
            console.log(
                "51 : bug_context : Error while calling bug report api calling::",
                error && JSON.stringify(error),
            );

            // Dispatching the actions on error
            dispatch({ type: CREATE_BUG_FAILURE, payload: error && error.message });
        }
    };

    // Function to Bug Report API
    const bugReportApi = async (title, apiUrl, method, error) => {
        try {
            // Fetch high-entropy OS values securely if supported by the browser
            if (navigator.userAgentData?.getHighEntropyValues) {
                try {
                    const uaDetails = await navigator.userAgentData.getHighEntropyValues(['platformVersion']);
                    osVersion = uaDetails.platformVersion || "Unknown";
                } catch (e) {
                    console.log("Could not read high entropy values", e);
                }
            }
            const payload = {
                "title": title,
                "userMessage": "",
                "type": "api_error",
                "severity": "high",
                "platformName": LONGSWITCH_ACADEMY,
                "browser": browser,
                "browserVersion": browserVersion,
                "operatingSystem": os,
                "operatingSystemVersion": osVersion,
                "device": device,
                "pageUrl": window.location.href,
                "apiUrl": apiUrl,
                "httpMethod": method,
                "httpStatusCode": error?.status || error?.response?.status || 400,
                "errorName": error?.name || "Error",
                "errorMessage": error?.message || "No error message provided",
                "stackTrace": error?.stack || "",
                "userId": userId,
                "metadata": ""
            };
            bugReport(payload);
        } catch (error) {
            console.log("95 : bug_context : Error while calling bug report api function::", error)
        }
    };

    return (
        <BugContext.Provider value={{ ...bugState, bugReportApi }}>
            {props.children}
        </BugContext.Provider>
    );
};

export const useBugContext = () => {
    return useContext(BugContext);
};
